import styled from 'styled-components';
import { Ivariant } from './main_type';

export const successSnack = { variant: 'success' as const };
export const warningSnack = { variant: 'warning' as const };
export const dVariant: Ivariant = 'standard';
export const dTiFormat = 'HHmmss' as const;
export const dTiFormatP = 'HH:mm:ss' as const;
export const dTi4Format = 'HHmm' as const;
export const dTi4FormatP = 'HH:mm' as const;
export const dDaFormat = 'yyyyMMdd' as const;
export const dDaFormatP = 'yyyy/MM/dd' as const;
export const dMaFormat = 'yyyyMM' as const;
export const dMaFormatP = 'yyyy/MM' as const;
export const dDaFms = [dDaFormat, dDaFormatP];
export const dDaTiFormat = 'yyyyMMdd HHmmss' as const;
export const dDaTiFormatN = 'yyyyMMddHHmmss' as const;
export const dDaTiFormatP = 'yyyy/MM/dd HH:mm:ss' as const;

export const colWidth: { [x: string]: number } = {
  appType: 110,
  boxNo: 140,
  boxName: 140,
  c1: 300,
  c2: 300,
  c3: 300,
  ake: 200,
  size20: 200,
  size40: 200,
  impPiece: 140,
  detainPiece: 140,
  outPiece: 140,
  path: 140,
  hwbNum: 140,
  pieceNum: 140,
  containerNo: 200,
  declNo: 350,
  expBagNo: 120,
  gciPiece: 110,
  gcoPiece: 110,
  goodsStat: 140,
  gciWeight: 200,
  hawbNo: 350,
  itemNo: 80,
  selected: 80,
  lastDeclNo: 350,
  // 主號
  mawbNo: 350,
  manifNo: 110,
  piece: 100,
  relDate: 200,
  voyageNo: 350,
  vesselRegNo: 160,
  warehouse: 300,
  weight: 140,
  // 進倉時間
  gciDate: 200,
  gciDate1: 200,
  gciDate2: 200,
  // 出倉時間
  gcoDate: 200,
  gcoDate1: 200,
  // 出倉日期
  gcoDate2: 200,
  impDate: 200,
  // 稅單號碼
  dutyNo: 180,
  // 進口納稅義務人
  dutyPayerNameC: 300,
  // 已列印(時間)
  printduty: 200,
  // 稅費合計
  totalDutyAmt: 120,
  // #region 稅費明細查詢
  dutyAmt: 200,
  dutyChargeCode: 200,
  // #endregion
  // 取消放行時間
  cancelRelease: 200,
  // 移退倉註記、作業註記
  closeMark: 160,
  vehicleDate: 200,
  delete: 100,
  storageDate: 160,
  expresssNameOrExpressId: 160,
  sealNo: 200,
  infoRec: 200,
  taxBasis: 130,
  dutyChargeCode1: 160,
  dutyChargeCode2: 160,
  dutyChargeCode3: 160,
  dutyChargeCode4: 160,
  dutyChargeCode5: 160,
  dutyChargeCode6: 160,
  dutyChargeCode7: 160,
  dutyChargeCode8: 160,
  dutyChargeCode9: 160,

  dutyAmt1: 160,
  dutyAmt2: 160,
  dutyAmt3: 160,
  dutyAmt4: 160,
  dutyAmt5: 160,
  dutyAmt6: 160,
  dutyAmt7: 160,
  dutyAmt8: 160,
  dutyAmt9: 160,

  // #region 下載專區
  // action: 160,
  downloadTime: 200,
  updTime: 200,
  isDownload: 110,
  status: 110,
  fileName: 200,
  // #endregion

  // #region  進口艙單資料查詢

  // 主號
  blNo: 350,
  // 進口日期
  importDate: 200,
  grossWeight: 160,
  numberOfPackages: 160,
  containerType: 200,
  shipName: 160,
  vesselCallSign: 160,
  packageUnit: 160,
  marks: 160,
  // #endregion
  totDutyAmt: 160,

  setdutycode: 140,
  setdutymark1: 350,
  setdutymark2: 350,
  processExcel: 200,

  defDutyCode: 160,
  defDutyMark1: 350,
  defDutyMark2: 350,
};

export const DivStyle = styled.div`
  border: 3px outset #1c6ea4;
  margin-bottom: 1rem;
`;

export const userTypeList = {
  /** 【快遞倉站】 SWH */
  type1: ['SWH'],
  /** 承攬業者 SFD、AFD */
  type2: ['SFD', 'AFD'],
  /** IE：【貨主】、2、3號碼為BK的：【報關業者】
   */
  type3: ['IE', 'BK'],
  /** 【海關】  'DKEL', 'DTPE', 'DTXG', 'DKHH' */
  type4: ['DKEL', 'DTPE', 'DTXG', 'DKHH'],
  /** 【貨主、承攬業、集運商、拖車行】  'PSP' */
  type5: ['PSP'],
  /** 【系統管理員】 EHUW */
  admin: ['EHUW'],
  /** 【關務署】 DGOC */
  topType: ['DGOC'],
  /** 【快遞倉站現場】 SWH_F */
  type6: ['SWH_F'],
  /** 【電商發票】 EBP */
  type7: ['EBP'],
  /** 【快遞倉特殊】 SWH_S */
  type8: ['SWH_S'],

  /** 【入出站登錄者】 IOREG */
  type9: ['IOREG'],
  type10: ['SWH_L'],
};
/**
 * 確認他是否為貨主(IE)報關業者(&BK&)
 * @param type
 * @returns
 */
export const isType3 = (type: string): boolean => {
  switch (type) {
    case 'IE':
    case 'BK':
      return true;

    default:
      if (type.indexOf('BK') === 1) {
        return isType3('BK');
      }
      return false;
  }
};

/**
 * 確認他是否為報關業者(&BK&)
 * @param type
 * @returns
 */
export const isTypeBK = (type: string): boolean => {
  switch (type) {
    case 'BK':
      return true;

    default:
      if (type && type.indexOf('BK') === 1) {
        return isType3('BK');
      }
      return false;
  }
};
/**
 * 確認他是否為貨主(&IE&)
 * @param type
 * @returns
 */
export const isTypeIE = (type: string): boolean => {
  switch (type) {
    case 'IE':
      return true;

    default:
      return false;
  }
};

/**
 * 查詢userType 身分
 * @param targetType 代入 userTypeList
 * @param userType 代入 login redux 的userType
 * @returns boolean
 */
export const isType = (targetType: string[], userType: string): boolean => {
  if (!userType) {
    return false;
  }
  if (targetType === userTypeList.type3) {
    return isType3(userType);
  }
  return targetType.some((v) => v === userType);
};

export const localeTw = {
  // Set Filter
  selectAll: '(全選)',
  selectAllSearchResults: '(選擇所有搜索結果)',
  searchOoo: '搜索...',
  blanks: '(空白)',
  noMatches: '無匹配項',

  // Number Filter & Text Filter
  filterOoo: '篩選器...',
  equals: '等於',
  notEqual: '不等於',
  empty: '選擇一個',

  // Number Filter
  lessThan: '小於',
  greaterThan: '大於',
  lessThanOrEqual: '小於或等於',
  greaterThanOrEqual: '大於或等於',
  inRange: '範圍內',
  inRangeStart: '至',
  inRangeEnd: 'from',

  // Text Filter
  contains: '包含',
  notContains: '不包含',
  startsWith: '開頭為',
  endsWith: '結尾為',

  // Date Filter
  dateFormatOoo: 'yyyy/mm/dd',

  // Filter Conditions
  andCondition: 'AND',
  orCondition: 'OR',

  // Filter Buttons
  applyFilter: '應用',
  resetFilter: '重置',
  clearFilter: '清除',
  cancelFilter: '取消',

  // Filter Titles
  textFilter: '文本篩選器',
  numberFilter: '數字篩選器',
  dateFilter: '日期篩選器',
  setFilter: '設置篩選器',

  // Side Bar
  columns: '欄位',
  filters: '篩選器',

  // columns tool panel
  pivotMode: 'Pivot Mode',
  groups: 'Row Groups',
  rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
  values: 'Values',
  valueColumnsEmptyMessage: 'Drag here to aggregate',
  pivots: 'Column Labels',
  pivotColumnsEmptyMessage: 'Drag here to set column labels',

  // Header of the Default Group Column
  group: 'Group',

  // Other
  loadingOoo: '正在加載...',
  noRowsToShow: '無資料',
  enabled: '啟用',

  // Menu
  pinColumn: '固定欄位',
  pinLeft: '固定左邊',
  pinRight: '固定右邊',
  noPin: '取消固定',
  valueAggregation: 'Value Aggregation',
  autosizeThiscolumn: '自動調整此欄位大小',
  autosizeAllColumns: '自動調整所有欄位大小',
  groupBy: 'Group by',
  ungroupBy: 'Un-Group by',
  resetColumns: '重置欄位',
  expandAll: '全部展開',
  collapseAll: '全部關閉',
  copy: '複製',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: '複製(含標題)',
  paste: '貼上',
  ctrlV: 'Ctrl+V',
  export: '匯出',
  csvExport: 'CSV 匯出',
  excelExport: 'Excel匯出(.xlsx)',
  excelXmlExport: 'Excel匯出(.xml)',

  // Enterprise Menu Aggregation and Status Bar
  sum: '總計',
  min: '最小值',
  max: '最大值',
  none: 'None',
  count: 'Count',
  avg: '平均',
  filteredRows: '已過濾',
  selectedRows: '已選擇',
  totalRows: '總筆數',
  totalAndFilteredRows: '行',
  more: 'More',
  to: '-',
  of: '/',
  page: '頁數:',
  nextPage: '下一頁',
  lastPage: '最後一頁',
  firstPage: '第一頁',
  previousPage: '上一頁',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',

  // ARIA
  ariaHidden: '隱藏',
  ariaVisible: '顯示',
  ariaChecked: '選取',
  ariaUnchecked: '未選取',
  ariaIndeterminate: 'indeterminate',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaInputEditor: 'Input Editor',
  ariaDateFilterInput: 'Date Filter Input',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterValue: 'Filter Value',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterToValue: 'Filter to value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaColumnToggleVisibility: 'column toggle visibility',
  ariaColumnGroupToggleVisibility: 'column group toggle visibility',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaSearch: '搜尋',
  ariaSearchFilterValues: '搜尋篩選值',
};
